<label  class="naps-label" [class.nsdc-disabled]="disabledField()">{{label()}}
  @if(isRequired()){
    <sup class="nsdc-text-error">*</sup>
    }
  </label> 
<mat-select #selectRef id="nsdc-select" [class.nsdc-disabled]="disabledField()" [formControl]="customFormControl()"
  [attr.aria-label]="ariaLabel()" (openedChange)="onOpenedChange($event)" [style.width]="width()"
  (valueChange)="emitValueOnOptionChange($event)" [placeholder]="placeholder()" [disabled]="disabledField()"
  [multiple]="isMultiSelect()" [canSelectNullableOptions]="canSelectNullableOptions()">
  <ng-content select="[first-option]">
    @if(placeholder()?.trim()?.length && showFirstOption()){
    <mat-option id="nsdc-option" [value]="" disabled><span
        class="nsdc-option w-100">{{placeholder()}}</span></mat-option>
    }
  </ng-content>
  @for(opt of options();track opt){
  @if(returnEntireObject()){
  <mat-option id="nsdc-option" [value]="opt">
    <span class="nsdc-option w-100">{{opt?.[labelKey()]}}</span>
  </mat-option>
  }@else{

  <mat-option id="nsdc-option"
    [value]="binCurrentLineIdWithValue() ? opt?.[valueKey()]+'#'+lineId() : opt?.[valueKey()]">
    <span class="nsdc-option w-100">{{opt?.[labelKey()]}}</span>
  </mat-option>
  }
  }
</mat-select>
@if(infoMessage()){
  <div class="d-inline-block info-section">
    <i class="sd sd-info-circle"></i> <span class="ml-1" >{{ infoMessage() }}</span> 
  </div>
}
<ng-content select="[error-message]">
  @if(isRequired() && (!customFormControl()?.valid && customFormControl()?.touched) ){
  <div class="nsdc-text-error">
    <i class="sd sd-info-circle"></i>
    <span>&nbsp; {{errorMessage() || 'Please Fill this is a Required Field'}}</span>
  </div>
  }
</ng-content>